/* eslint-disable react-native/no-inline-styles */
import React, {useEffect} from 'react';
import {Image, Button} from '@/components-v2';
import {useTranslation} from 'react-i18next';
import freelottery from '../assets/freelottery.webp';
import headerBg from '../assets/header-bg.webp';
import {goTo} from '@utils';
import globalStore from '@services/global.state';
import {currentBrand} from '@/brands';

function toLogin() {
  goTo('Login');
}

const goSearch = () => {
  goTo('search');
};
const SearchEntry = () => {
  return (
    <Image
      src={require('@/assets/icons/home/search.png')}
      className="w-6 h-6"
      onClick={goSearch}
    />
  );
};
export default function HomeHeader({
  onRightClick = () => {},
}: {
  onRightClick?: () => void;
}) {
  const {t} = useTranslation();
  const [login, setLogin] = React.useState(false);
  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      setLogin(!!token);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  return (
    <div
      className="h-11 px-3 flex items-center z-10 justify-between bg-cover bg-no-repeat"
      style={{
        backgroundImage: `url(${headerBg})`,
      }}>
      <div className="flex flex-row items-center">
        <div className="h-[1.75rem] w-[1.75rem] rounded-md mr-3">
          <Image
            alt="logo"
            className="h-[1.75rem] w-[1.75rem] rounded-md mr-3"
            src={require('@assets/icons/logo.png')}
          />
        </div>
        <p className="font-bold text-base text-white">{currentBrand.appName}</p>
      </div>
      {login ? (
        <div className="flex gap-1 items-center">
          <div onClick={onRightClick} className="full-h w-[6.75rem]">
            <Image
              alt="freelottery"
              src={freelottery}
              className="full-h w-[6.75rem]"
            />
          </div>
          <SearchEntry />
        </div>
      ) : (
        <div className="flex gap-1 items-center">
          <Button
            onClick={() => toLogin()}
            className="w-[5.0625rem] h-[1.9375rem] px-3 py-2 rounded-3xl text-[#E91100] text-xs font-bold"
            style={{
              boxShadow: '0px 1.5px 0px 0px #FFCCC7 inset',
            }}>
            {t('me.user.loginUpper')}
          </Button>
          <SearchEntry />
        </div>
      )}
    </div>
  );
}
